import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import type {OddsByWidgetController} from "../odds-by-widget.controller";
import type {OddsByWidgetState} from "../models/odds-by-widget.state";

export class OddsByWidgetFetchHandler extends FetchHandler {
  controller: OddsByWidgetController;
  state: OddsByWidgetState;

  static injectables = [];
  async onLoaded() {
    super.onLoaded();

    this.action();
  }

  async action(params) {
    this.controller.props.onWidgetVisible?.(this.state.shouldRenderWidget);
  }

}
